import { createTheme } from '@mui/material/styles';

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      t100: '#0A7BB8',
      t70: '#4DA8D9',
      t50: '#80C1E4',
      t20: '#CCE6F4',
      light: '#757ce8',
      main: '#3f50b5',
      dark: '#002884',
    },
    secondary: {
      t100: '#49BD99',
      t70: '#80D1B8',
      t50: '#A4DECC',
      t20: '#EDF8F5',
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
    },
    tertiary: {
      t100: '#2E3192',
      t70: '#6D6FB3',
      t50: '#9698C8',
      t20: '#D5D6E9',
    },
    text: {
      t100: '#04223F',
      t70: '#4F6479',
      t50: '#81909F',
      t20: '#CDD3D9',
      dark: '#0E3963',
    },
    neutral: {
      one: '#F9FCFF',
      two: '#F7F9FA',
      three: '#EAEFF3',
      four: '#DDE9EF',
      five: '#CCE6F4',
      six: '#CDD3D9',
      seven: '#FCFEFF',
      white: '#FFFFFF',
      black: '#000000',
    },
    semantic: {
      confirm: '#AFD245',
      error: '#EE6363',
      attention: '#FFEF64',
      accent: '#F50057',
      confirm2: '#EFF6DA',
      error2: '#FFE3E3',
      attention2: '#FFFCE1',
    },
  },
  typography: {
    //fontSize in pixels
    fontSize: 16,
    font: 'Rubik',
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: '12px',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: '12px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          outline: 'none',
          '&:focus': {
            outline: 'none',
          },
        },
      },
    },
  },
});

export default theme;
